import actionCreatorFactory from 'typescript-fsa';

import { FormName } from '@topconagriculture/feed-types';

import reduxConfig from '../../config';
import { LotMarketType } from './lotMarketTypes.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/lotMarketTypes');

export const getLotMarketTypes = actionCreator.async<{}, LotMarketType[]>('GET_LOT_MARKET_TYPES');
export const createLotMarketType = actionCreator.async<
  { data: Partial<LotMarketType>; formName: FormName },
  LotMarketType
>('CREATE_LOT_MARKET_TYPE');
export const updateLotMarketType = actionCreator.async<
  { data: Partial<LotMarketType>; formName: FormName },
  LotMarketType
>('UPDATE_LOT_MARKET_TYPE');
export const deleteLotMarketType = actionCreator.async<{ id: string; formName: FormName }, string>(
  'DELETE_LOT_MARKET_TYPE',
);
